{
  "markupConditionList": [],
  "showOnlyValidMarkupCondition": true
}
